export interface NoiseItem {
    coord: {x: number; y: number} | null;
    kategorie: string;
    name: string | null;
    dbLow: number | null;
    dbHigh: number | null;
    distanceM: number | null;
    dB: string;
}

/** `dB`-Wert ohne jede Belastung, auch nicht in der Umgebung. */
export const NOISE_DB_NO_IMPACT = "no impact in the surrounding area";
/** `dB`-Wert ohne Belastung am Punkt selbst, aber mit Belastung in der Umgebung (ohne dB-Klasse). */
export const NOISE_DB_IMPACT_SURROUNDING = "no impact";

/** Anzeigetext für `dB`: die beiden Sonderwerte übersetzt, sonst der dB-Bereich unverändert. */
export function noiseLevelLabel(dB: string, t: (key: string) => string): string {
    if (dB === NOISE_DB_NO_IMPACT) return t("noise.no_impact");
    if (dB === NOISE_DB_IMPACT_SURROUNDING) return t("noise.impact_surrounding_area");
    return dB;
}

export interface AvmApiLocationInfoNoise {
    noise: NoiseItem[];
}
